import instance from "./axiosInstance";

//get all menu data
export const login_admin = async (params) => {
  try {
    const response = await instance.post(`/api/admin/login`, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

//get all menu data
export const getUsers = async (id) => {
  try {
    const response = await instance.get(`/api/admin/getAllUsers`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const deleteUserById = async (id) => {
  try {
    const response = await instance.post(`/api/admin/deleteAccount`, {
      userId: id,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addUser = async (params) => {
  try {
    const response = await instance.post(`/api/admin/userRegistration`, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateUserById = async (id, params) => {
  try {
    const response = await instance.put(`/api/admin/editProfile/${id}`, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const interstedMatch = async () => {
  try {
    const response = await instance.get(`/api/admin/getIntersted`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const report = async () => {
  try {
    const response = await instance.get(`/api/reports`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteReportById = async (id) => {
  try {
    const response = await instance.delete(`/api/reports/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateUserProfileImage = async (id, params) => {
  try {
    const response = await instance.post(
      `/api/admin/uploadUserImage/${id}`,
      params,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

//get all Notifications
export const getNotifications = async (id) => {
  try {
    const response = await instance.get(`/api/admin/getNotification`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const add_CustomNotification = async (params) => {
  try {
    const response = await instance.post(`/api/admin/addNotification`, params, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendNotification = async (params) => {
  try {
    const response = await instance.post(
      `/api/admin/sendNotifications`,
      params
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDashboardCounts = async () => {
  try {
    const response = await instance.get(`/api/dash-counts`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteNotificationById = async (id) => {
  try {
    const response = await instance.post(`/api/admin/notificationDelete`, {
      notificationId: id,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllPayments = async () => {
  try {
    const response = await instance.get(`/api/admin/getAllPayments`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
